"use strict";
/**
 * Logger-category catalogue for the ediabasx subsystem.
 *
 * Consumer apps (ediabasx-web Settings dialog, inpax-web Settings,
 * future ncsx-web) iterate this array to build per-category controls
 * without hardcoding category names. Hints surface as tooltips /
 * sublabels.
 *
 * Add an entry here whenever a new `getLogger("EDIABASX.*")` call site
 * lands that's worth exposing to end users. Internal-only categories
 * (test fixtures, dev scripts) stay out — they'd just clutter the
 * Settings UI.
 *
 * The hint must be one sentence; longer copy belongs in docs.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOG_CATEGORIES = void 0;
exports.LOG_CATEGORIES = [
    {
        name: "EDIABASX",
        hint: "Catch-all for the ediabasx subsystem — overrides any unmatched subtree below.",
    },
    {
        name: "EDIABASX.ediabas",
        hint: "SGBD load / variant resolve / job dispatch lifecycle.",
    },
    {
        name: "EDIABASX.ediabas.config-loader",
        hint: "Per-config-file load events (createFromConfigFile, loadConfig).",
    },
    {
        name: "EDIABASX.ediabas.wire",
        hint: "Reserved — raw send / recv / xsend bytes (populated by future interface-side migration).",
    },
];
//# sourceMappingURL=log-categories.js.map